var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57 5.5A7.059 7.059 0 007.662 8h-.828C5.171 8 4 9.268 4 10.619v10.237c0 1.35 1.17 2.618 2.833 2.618h10.112l.632.425 2.756 1.852V13.5h2.5V28.476c0 .566-.477 1.024-1.066 1.024-.22 0-.433-.065-.612-.185l-4.972-3.34h-9.35c-2.945 0-5.333-2.292-5.333-5.12V10.62C1.5 7.792 3.888 5.5 6.833 5.5h.738z",
    fill: "#121314"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 0.5,
    width: 26,
    height: 12,
    rx: 6,
    fill: "#0FADFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.509 9.5h1.44V5.908L16.037 9.5h1.584V3.78h-1.432v3.224L14.357 3.78h-1.848V9.5zm6.219 0h4.08V8.236H20.36v-1.04h1.848V6.028H20.36v-.984h2.32V3.78h-3.952V9.5zm5.786 0h1.6l.888-3.632.88 3.632h1.712l1.336-5.72h-1.52l-.776 3.6-.832-3.6h-1.456l-.768 3.568-.736-3.568h-1.656l1.328 5.72z",
    fill: "#fff"
  })));
}
export default SvgChatNew;